export default __webpack_public_path__ + "static/media/cardboard_study_1.58870b91.jpg";